import qs from 'qs';
import envs from "../utils/envs.js"
import { getEnvName } from "../utils/env.js";
import http from "../h5-network/request.js";

export default function () {
    return new Promise((resolve, reject) => {
        getEnvName()
            .then(function (envName) {
                const env = envs[envName];
                const login = env?.login;
                const url = qs.parse(location.search.slice(1));

                if (!login?.isLogin) resolve(envName);

                login.isLogin().then(
                    () => {
                        if (!url.tmrId) {
                            //判断是否是金牛用户
                            http({
                                loading: true,
                                url: '/bdzb-core-service/eva/userLoginToJudge',
                                data: {},
                                method: 'POST',
                            }).then(({ BaFlag }) => {
                                //金牛保宝 BaFlag == '1'
                                if (BaFlag == '1') {
                                    let pathname = location.pathname.replace(
                                        'investadviser',
                                        'investadviser-jnb'
                                    );
                                    if (process.env.VUE_APP_ENV_TYPE == 'development') {
                                        pathname = '/wmpages/investadviser-jnb' + location.pathname;
                                    }
                                    location.href =
                                        process.env.VUE_APP_DOMAIN +
                                        pathname +
                                        '?' +
                                        login.linkSearch({ ...url });
                                } else {
                                    resolve(envName)
                                }
                            }, () => resolve(envName));
                        } else {
                            resolve(envName)
                        }
                    },
                    () => resolve(envName))
            })
    })
}